import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button, Checkbox, Collapse, FormControlLabel, FormGroup, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { updateShipping, validOptionalAddress, validRequiredAddress } from "./client_halper";
import { validIndianPin } from "../booking/booking_halper";

function ShippingEdit({ client, onChange }) {
    const [inputErrors, setInputErrors] = useState({});
    const [expanded, setExpanded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const add_1 = data.get("shipping_add_1");
        const add_2 = data.get("shipping_add_2");
        const add_3 = data.get("shipping_add_3");
        const state = data.get("shipping_add_state");
        const zip = data.get("shipping_add_zip");
        var flag = true;
        if (__error_handler(validRequiredAddress(add_1), "shipping_add_1", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validRequiredAddress(add_2), "shipping_add_2", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validOptionalAddress(add_3), "shipping_add_3", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(["Jharkhand", "Bihar", "Orrisa", "West Bangal"].includes(state), "shipping_add_state", "Must be an indian state")) {
            flag = false;
        }
        if (__error_handler(validIndianPin(zip), "shipping_add_zip", "You have entered an invalid pin code.")) {
            flag = false;
        }
        if (flag) {
            const _json = {
                "shipping_add_1": add_1, "shipping_add_2": add_2, "shipping_add_3": add_3,
                "shipping_add_state": state, "shipping_add_zip": zip, "client": client.client_id
            };
            updateShipping(_json).then((_) => {
                delete _json["auth"];
                onChange({ status: "loaded", message: "change", change: _json });
                setIsLoading(false);
            }).catch((err) => {
                onChange({ status: "loaded", message: "failed", error: err.message });
                setIsLoading(false);
            });
        } else {
            onChange({ status: "loaded", message: "validation_error" });
            setIsLoading(false);
        }
    }

    const validateInputs = (event) => {
        onChange({ status: "loading" });
        return true;
    }

    const handleAddressCopy = (e) => {
        if (e.target.checked) {
            document.getElementsByName("shipping_add_1")[0].value = client["billing_add_1"];
            document.getElementsByName("shipping_add_2")[0].value = client["billing_add_2"];
            document.getElementsByName("shipping_add_3")[0].value = client["billing_add_3"];
            document.getElementsByName("shipping_add_state")[0].value = client["billing_add_state"];
            document.getElementsByName("shipping_add_zip")[0].value = client["billing_add_zip"];
        }
    }

    return (
        <Box>
            <Button style={{ textTransform: "none" }} onClick={() => { setExpanded(!expanded); }}>
                {expanded ? <ExpandMore /> : <ExpandLess />} Shipping Address
            </Button>
            <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ mt: 1 }}>
                <Grid container spacing={2} component="form" onSubmit={handleSubmit} noValidate>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="shipping_add_1" defaultValue={client.shipping_add_1} fullWidth error={inputErrors.shipping_add_1} type="text" helperText={inputErrors.shipping_add_1} placeholder="Address line 1" label="Line 1" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="shipping_add_2" defaultValue={client.shipping_add_2} fullWidth error={inputErrors.shipping_add_2} type="text" helperText={inputErrors.shipping_add_2} placeholder="Address line 2" label="Line 2" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="shipping_add_3" defaultValue={client.shipping_add_3} fullWidth error={inputErrors.shipping_add_3} type="text" helperText={inputErrors.shipping_add_3} placeholder="Address line 3" label="Line 3" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="shipping_add_state" defaultValue={client.shipping_add_state} fullWidth error={inputErrors.shipping_add_state} type="text" helperText={inputErrors.shipping_add_state} placeholder="State" label="State" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="shipping_add_zip" defaultValue={client.shipping_add_zip} fullWidth error={inputErrors.shipping_add_zip} type="text" helperText={inputErrors.shipping_add_zip} placeholder="Pincode" label="Pincode" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox defaultChecked={false} />} label="Same as billing address" onClick={handleAddressCopy} />
                        </FormGroup>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button type="submit" variant="outlined" fullWidth onClick={validateInputs} color="secondary">Save</Button>
                    </Grid>
                </Grid>
            </Collapse>
        </Box>
    );
}

export default ShippingEdit;
